import { render, staticRenderFns } from "./adVideoList.vue?vue&type=template&id=6680bdd6&scoped=true"
import script from "./adVideoList.vue?vue&type=script&lang=js"
export * from "./adVideoList.vue?vue&type=script&lang=js"
import style0 from "./adVideoList.vue?vue&type=style&index=0&id=6680bdd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680bdd6",
  null
  
)

export default component.exports